import { ErrorHandler, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import {
  FormGroupDirective,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { HttpModule } from "@angular/http";
import { HttpClientModule } from "@angular/common/http";
import {
  DatePipe,
  HashLocationStrategy,
  LocationStrategy,
} from "@angular/common";
import { YoutubePlayerModule } from "ng2-youtube-player";
import { NgwWowModule } from "ngx-wow";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FileDropModule } from "ngx-file-drop";
import { NgSpinKitModule } from "ng-spin-kit";

import { RecaptchaModule } from "ng-recaptcha";
import { RecaptchaFormsModule } from "ng-recaptcha/forms";

import { AppComponent } from "./app.component";
import { routing } from "./app.routing";

// Import the new SelectOrgansComponent
import { SelectOrgansComponent } from "./common/select-organs/select-organs.component";

import {
  AlertComponent,
  CountryValidator,
  NestValidator,
  NgbdModalBasic,
  PageHeaderComponent,
  PasswordValidator,
  PersonalIdAdminValidator,
  PersonalIdValidator,
  PhoneValidator,
  RepeatPasswordValidator,
  TextComponent,
} from "./_directives/index";

import { HomeComponent } from "./home/index";

import {
  CartComponent,
  QuestionsComponent,
  QuestionsModal,
} from "./cart/index";
import { LegacyLoginComponent } from "./login/legacy-login/legacy-login.component";
import { TwoFactorLoginComponent } from "./login/2fa-login/2fa-login.component";
import { RegisterComponent } from "./register/index";
import { ForgotPasswordComponent } from "./forgotpassword/forgotpassword.component";
import { CheckoutComponent } from "./checkout/checkout.component";
import { BrothersComponent, BrothersPanelComponent } from "./brothers/index";
import {
  ChildModal,
  CreateChildComponent,
  SearchChildModal,
  ViewChildComponent,
} from "./child/index";
import { RefundLogicComponent } from "./refund/index";
import {
  HistoryActionComponent,
  HistoryComponent,
  HistoryDetailComponent,
  HistoryFieldComponent,
  PaymentNotOkComponent,
  PaymentOkComponent,
  RefundComponent,
} from "./payment/index";
import { SearchComponent } from "./search/search.component";
import {
  EditParentComponent,
  RegisteredUserComponent,
  SearchParentComponent,
  ViewParentComponent,
} from "./registereduser/index";

import { NgIdleKeepaliveModule } from "@ng-idle/keepalive";
import {
  NgbActiveModal,
  NgbModule,
  NgbTooltipModule,
} from "@ng-bootstrap/ng-bootstrap";
import { VirtualScrollerModule } from "ngx-virtual-scroller";
import { ChartsModule } from "ng2-charts";

// ag-grid
import { AgGridModule } from "ag-grid-angular/main";
import { ToastModule } from "ng2-toastr/ng2-toastr";
import { NgxEditorModule } from "ngx-editor";
import { LocalStorageManagerService } from "./_services/localStoageManager.service";
import { LocationManagerService } from "./_services/locationManager.service";
import { ParentService } from "./_services/parent.service";
import { ApprovalModalComponent } from "./common/approval-modal/approval-modal.component";
import { GlobalErrorHandler } from "./common/error-handler/global-error-handler";
import { SessionManagerService } from "./_services/SessionManager/session-manager.service";
import { I18nService } from "./_services/i18n.service";
import { ParentEventsPageComponent } from "./admin/events-screen/parent-events-page/parent-events-page.component";
import { EventsService } from "./_services/eventsServices/events.service";
import { ParentEventsRowComponent } from "./admin/events-screen/parent-events-row/parent-events-row.component";
import { ParentEventsRowHeaderComponent } from "./admin/events-screen/parent-events-row-header/parent-events-row-header.component";
import { ParentEventsRowDetailsComponent } from "./admin/events-screen/parent-events-row-details/parent-events-row-details.component";
import { ParentEventsRowDetailsChildEventsRowComponent } from "./admin/events-screen/parent-events-row-details-child-events-row/parent-events-row-details-child-events-row.component";
import { GenericActionMenuComponent } from "./form/generic-action-menu/generic-action-menu.component";
import { ParentEventsMessagesComponent } from "./admin/events-screen/parent-events-messages/parent-events-messages.component";
import { EventPageLoadingAnimationComponent } from "./admin/events-screen/event-page-loading-animation/event-page-loading-animation.component";
import { EventPageModal } from "./admin/events-screen/event-page-modal/event-page-modal.component";
import { EventPageSearchComponent } from "./admin/events-screen/parent-events-page/event-page-search/event-page-search.component";
import { TooltipDirective } from "./_directives/app-tooltip.directive";
import { CreateParentEventFormComponent } from "./admin/events-screen/create-parent-event-form/create-parent-event-form.component";
import { GenericFormComponent } from "./form/generic-form/generic-form.component";
import { CreateParentEventPageFormUsersPermissions } from "./admin/events-screen/create-parent-event-page-form-users-permissions/create-parent-event-page-form-users-permissions.component";
import { CreateParentEventUserPermissionRow } from "./admin/events-screen/create-parent-event-page-form-users-permissions/create-parent-event-page-user-permission-row/create-parent-event-user-permission-row.component";
import { CreateParentEventFormParentQuestionsComponent } from "./admin/events-screen/create-parent-event-form-parent-questions/create-parent-event-form-parent-questions.component";
import { CreateParentEventFormParentQuestionsCardComponent } from "./admin/events-screen/create-parent-event-form-parent-questions-card/create-parent-event-form-parent-questions-card.component";
import { SelectMenuComponent } from "./form/select-menu/select-menu.component";
import { QuestionsCardOptionComponent } from "./admin/events-screen/create-parent-event-form-parent-questions-card/question-card-option/questions-card-option.component";
import { GenericModalComponent } from "./form/generic-app-modal/generic-modal.component";
import { WhiteBoardComponent } from "./admin/events-screen/white-board/white-board.component";
import { SelectDateComponent } from "./form/select-date/select-date.component";
import { CreateParentEventFormMainDetailsComponent } from "./admin/events-screen/create-parent-event-form-main-details/create-parent-event-form-main-details.component";
import { CreateParentEventFormPricingListComponent } from "./admin/events-screen/create-parent-event-form-pricing-list/create-parent-event-form-pricing-list.component";
import { CreateParentEventFormPricingRowComponent } from "./admin/events-screen/create-parent-event-form-pricing-row/create-parent-event-form-pricing-row.component";
import { CreateParentEventFormPricingNestsComponent } from "./admin/events-screen/create-parent-event-form-pricing-nests/create-parent-event-form-pricing-nests.component";
import { ParentEventsPageMainModalContainerComponent } from "./admin/events-screen/parent-events-page-main-modal-container/parent-events-page-main-modal-container.component";
import { GenericAutoCompleteComponent } from "./form/generic-auto-complete/generic-auto-complete.component";
import { EventsTypeManagementRowHeaderComponent } from "./admin/event-type-management/events-type-row-header/events-type-management-row-header.component";
import { EventTypeManagementScreenComponent } from "./admin/event-type-management/event-type-management-screen.component";
import { EventsTypeManagementRowComponent } from "./admin/event-type-management/events-type-row/events-type-management-row.component";
import { EventsTypesManagementService } from "./_services/events-management.service";
import { EventSerializerService } from "./_services/eventsServices/eventSerializer.service";
import { EventValidationService } from "./_services/eventsServices/eventValidation.service";
import { InfiniteScrollerDirective } from "./_directives/scroll-directive/infinite-scroll.directive";
import { CreateParentEventFormCustomComponent } from "./admin/events-screen/create-parent-event-form-custom/create-parent-event-form-custom.component";
import { SpecialTypeEventsService } from "./_services/eventsServices/specialTypeEvents.service";
import { BrothersAttributionPage } from "./admin/brothers-attribution/brothers-attribution-page/brothers-attribution-page.component";
import { TranslationService } from "./_services/translation.service";
import { BrotherAttributionPageMainModalContainerComponent } from "./admin/brothers-attribution/brother-attribution-page-main-modal-container/brother-attribution-page-main-modal-container.component";
import { BrotherAttributionChildSelector } from "./admin/brothers-attribution/brother-attribution-child-selector/brother-attribution-child-selector.component";
import { BrotherAttributionService } from "./_services/brother-attribution.service";
import { FamilyEditFormComponent } from "./admin/brothers-attribution/family-edit-form/family-edit-form.component";
import { FamilyCreationFormComponent } from "./admin/brothers-attribution/family-creation-form/family-creation-form.component";
import { BrotherAttributionFamilyEditorComponent } from "./admin/brothers-attribution/brother-attribution-family-editor/brother-attribution-family-editor.component";
import { LegacyBrotherAttributionMainChildSearchComponent } from "./admin/brothers-attribution/brothers-attribution-page/leagcy-brother-attribution-main-child-search/legacy-brother-attribution-main-child-search.component";
import { BrotherAttributionSearchChildComponent } from "./admin/brothers-attribution/brothers-attribution-page/brother-attribution-search-child/brother-attribution-search-child.component";
import { BrotherAttributionRequestRow } from "./admin/brothers-attribution/brother-attribution-search-results/brother-attribution-request-row/brother-attribution-request-row.component";
import { BrotherAttributionRequestRowHeader } from "./admin/brothers-attribution/brother-attribution-search-results/brother-attribution-request-row-header/brother-attribution-request-row-header.component";
import { BrotherAttributionBriefResultsViewComponent } from "./admin/brothers-attribution/brother-attribution-brief-results-view/brother-attribution-brief-results-view.component";
import { PopoverService } from "./_services/popover.service";
import { PopoverContainerComponent } from "./_directives/popover/popover-container.component";
import { LegacyHeaderComponent } from "./header/legacyHeader/legacy-header.component";
import { AccessibilityComponent } from "./addons/accessibility.component";
import { QuestionsAnswersComponent } from "./header/questionsanswers.component";
import { AppHeaderComponent } from "./header/app-header/app-header.component";
import { MeshutafUsersComponent } from "./admin/meshutaf-users/meshutaf-users.component";
import { MeshutafUserFormComponent } from "./admin/meshutaf-users/meshutaf-user-form.component";
import { AuthGuard } from "./_guards/auth.guard";
import { StagingGuard } from "./_guards/staging.guard";
import { EventNamePipe } from "./_helpers/event-name-pipe";
import { KeysPipe } from "./_helpers/keys-pipe";
import { UserPipe } from "./_helpers/user-pipe";
import { TrimTextPipe } from "./_helpers/trim-text-pipe";
import { ApplicationService } from "./_services/application.service";
import { AlertService } from "./_services/alert.service";
import { AuthenticationService } from "./_services/authentication.service";
import { DataService } from "./_services/data.service";
import { HttpWrapperService } from "./_services/http.wrapper.service";
import { UserManagementPageComponent } from "./admin/users/user-management-page/user-management-page.component";
import { UsersManagementSearchComponent } from "./admin/users/user-management-page/user-management-search/user-management-search.component";
import { FigmaLinkComponent } from "./development/figma/figma.link.component";
import { UserManagementRowComponent } from "./admin/users/user-management-row/user-management-row.component";
import { UserManagementRowHeaderComponent } from "./admin/users/user-management-row-header/user-management-row-header.component";
import { RangeSelectComponent } from "./admin/components/range-select/range-select.component";
import { AdminComponent } from "./admin/admin/admin.component";
import { MihlolModal } from "./admin/mihlol/mihlolmodal.component";
import { MihlolComponent } from "./admin/mihlol/mihlol.component";
import { ContentComponent } from "./admin/content/content.component";
import { RikuzComponent } from "./admin/rikuz/rikuz.component";
import { RefundsAdminComponent } from "./admin/refunds/refundsAdmin.component";
import { CirleBrDiscountsComponent } from "./admin/circle_discounts/circleBrDiscounts.component";
import { EventMeshutafComponent } from "./admin/meshutaf/event-meshutaf.component";
import { SelectAreaComponent } from "./admin/components/select-area/select-area.component";
import { AutoCompleteComponent } from "./admin/components/auto-complete/auto-complete.component";
import { MultiSelectComponent } from "./admin/components/multi-select/multi-select.component";
import { CashComponent } from "./admin/components/cash/cash.component";
import { OpenReceiptsComponent } from "./admin/teshlumon/open-receipts/open-receipts.component";
import { PaymentsComponent } from "./admin/payments/payments.component";
import { PaymentResultComponent } from "./admin/payments/payemnt-result/payment-result.component";
import { RefundInlineComponent } from "./admin/payments_refunds/refund-inline.component";
import { RefundBlockComponent } from "./admin/payments_refunds/refund-block.component";
import { SingleReceiptComponent } from "./admin/teshlumon/open-receipts/single-receipt.component";
import { DepositModalComponent } from "./admin/teshlumon/open-receipts/deposit-modal.component";
import { CollectiveReceiptComponent } from "./admin/teshlumon/collective-receipt/collective-receipt.component";
import { BooleanComponent } from "./admin/components/boolean/boolean.component";
import { UserManagementService } from "./_services/user-management.service";
import { TextTrimPopoverComponent } from "./common/text-trim-popover/text-trim-popover.component";
import { LegacyTextTrimPopoverComponent } from "./common/text-trim-popover/legacy-text-trim-popover.component";
import { GenericCheckBoxComponent } from "./common/generic-check-box/generic-checkbox.component";
import { GenericCheckBoxWithMinusComponent } from "./common/generic-check-box-with-minus/generic-checkbox-with-minus.component";
import { UserManagementUploadUsersExcelModalComponent } from "./admin/users/user-management-upload-users-excel-modal/user-management-upload-users-excel-modal.component";
import { UploadExcelFileInterfaceComponent } from "./admin/users/user-management-upload-users-excel-modal/upload-excel-file-interface/upload-excel-file-interface.component";
import { UserManagementSearchBoxComponent } from "./admin/users/user-management-page/user-management-search-box/user-management-search-box.component";
import { MultiSelectNestsComponent } from "./common/multi-select-nests/multi-select-nests.component";
import { GlobalDataService } from "./_services/global-data.service";
import { UserManagementFormComponent } from "./admin/users/user-management-form/user-management-form.component";
import { UserManagementFormMainModalContainerComponent } from "./admin/users/user-management-form-main-modal-container/user-management-form-main-modal-container.component";
import { UserManagementFormPersonalDetailsComponent } from "./admin/users/user-management-form-personal-details/user-management-form-personal-details.component";
import { DevelopmentComponent } from "./development/development.component";
import { StoriesComponent } from "./development/stories/stories.component";
import { AsyncValidationIndicatorComponent } from "./common/async-validation-indicator/async-validation-indicator.component";
import { SpinnerWithCheckMarkComponent } from "./common/spinner-with-check-mark/spinner-with-check-mark.component";
import { FormFieldErrorComponent } from "./common/form-field-error/form-field-error.component";
import { UserManagementFormSystemPrivilegesComponent } from "./admin/users/user-management-form-system-privileges/user-management-form-system-privileges.component";
import { CodeCubesComponent } from "./common/code-cubes/code-cubes.component";
import { PinCodeInputComponent } from "./common/pin-code-input/pin-code-input.component";
import { UserManagementFormActivityFieldsComponent } from "./admin/users/user-management-form-activity-fields/user-management-form-activity-fields.component";
import { UserManagementFormActivityNestsComponent } from "./admin/users/user-management-form-activity-nests/user-management-form-activity-nests.component";
import { UserManagementFormPasswordManagementComponent } from "./admin/users/user-management-form-password-management/user-management-form-password-management.component";
import { DateRangeSelectComponent } from "./common/date-range-select/date-range-select.component";
import { UserManagementActivityForm } from "./admin/users/user-management-activity-form/user-management-activity-form";
import { PasswordResetModalComponent } from "./admin/users/password-reset-modal/password-reset-modal.component";
import { UserManagementBriefResultsViewComponent } from "./admin/users/user-management-page/user-management-brief-results-view/user-management-brief-results-view.component";
import { MultiSelectMenuComponent } from "./form/multi-select-menu/multi-select-menu.component";
import { LoggerModule } from "./modules/logger.module";
import { DevSelectMenuComponent } from "./development/ui/dev-select-menu.component";
import { PasswordResetService } from "./_services/password-reset.service";
import { PasswordResetApprovalModalComponent } from "./admin/users/password-reset-approval-modal/password-reset-approval-modal.component";
import { RestUserPasswordComponent } from "./reset-user-password/rest-user-password.component";
import { DiscountManagementBriefResultsViewComponent } from "./admin/discounts/discount-management-page/discount-management-brief-results-view/discount-management-brief-results-view.component";
import { DiscountManagementPageComponent } from "./admin/discounts/discount-management-page/discount-management-page.component";
import { DiscountManagementSearchBoxComponent } from "./admin/discounts/discount-management-page/discount-management-search-box/discount-management-search-box.component";
import { DiscountManagementSearchComponent } from "./admin/discounts/discount-management-page/discount-management-search/discount-management-search.component";
import { MultiSelectEventsComponent } from "./common/multi-select-events/multi-select-events.component";
import { DiscountManagementSearchChildComponent } from "./admin/discounts/discount-management-page/discount-management-search-child/discount-management-search-child.component";
import { MultiSelectLayersComponent } from "./common/multi-select-layers/multi-select-layers.component";
import { DevDiscountTableStoryComponent } from "./development/ui/dev-discount-table-story.component";
import { DiscountManagementRowComponent } from "./admin/discounts/discount-management-row/discount-management-row.component";
import { NewDiscountFormComponent } from "./admin/discounts/new-discount-form/new-discount-form.component";
import { DiscountManagementFormMainModalContainerComponent } from "./admin/discounts/discount-management-form-main-modal-container/discount-management-form-main-modal-container.component";
import { NewDiscountFormSelectEventComponent } from "./admin/discounts/new-discount-form-select-event/new-discount-form-select-event.component";
import { NewDiscountFormSelectEventParentComponent } from "./admin/discounts/new-discount-form-select-event-parent/new-discount-form-select-event-parent.component";
import { DiscountManagementService } from "./_services/discount-management.service";
import { NewDiscountFormSelectChildrenComponent } from "./admin/discounts/new-discount-form-select-children/new-discount-form-select-children.component";
import { NewDiscountFormSelectPriceComponent } from "./admin/discounts/new-discount-form-select-price/new-discount-form-select-price.component";
import { NewDiscountFormSummaryComponent } from "./admin/discounts/new-discount-form-summary/new-discount-form-summary.component";
import { EditDiscountFormComponent } from "./admin/discounts/edit-discount-form/edit-discount-form.component";
import { DiscountManagementDeleteModalComponent } from "./admin/discounts/discount-management-delete-modal/discount-management-delete-modal.component";
import { EditDiscountFormSelectPriceComponent } from "./admin/discounts/edit-discount-form-select-price/edit-discount-form-select-price.component";
import { AppSpinnerComponent } from "./common/app-spinner/app-spinner.component";
import { AppLoadingDataComponent } from "./common/app-loading-data/app-loading-data.component";
import { LanguageService } from "./_services/language.service";
import { DevToolsService } from "./_services/dev-tools.service";
import { DevEndpointExampleComponent } from "./development/example/dev-endpoint-example.component";
import { DiscountManagementSearchEventComponent } from "./admin/discounts/discount-management-page/discount-management-search-event/discount-management-search-event.component";
import { MockTestComponent } from "./development/example/mock-test.component";
import { FreePayComponent } from "./admin/components/free-pay/free-pay.component";
import { GenericChartComponent } from "./admin/charts/generic-chart/generic-chart.component";
import { GenericChartModalContainerComponent } from "./admin/charts/generic-chart-modal/generic-chart-modal-container.component";
import { ChartService } from "./_services/chart.service";
import { LastStoriesComponent } from "./development/last-stories/last-stories.component";
import { ContributionComponent } from "./checkout/contribution/contribution.component";
import { WaveEffect } from "./UI/wave-effect";
import { FilesService } from "./_services/files.service";
import { DevSelectOrganComponent } from "./development/ui/dev-select-organ.component";
import { SelectOrgansCustomMultiSelectComponent } from "./common/select-organs/select-organs-custom-multi-select/select-organs-custom-multi-select.component";
import { SelectLayersComponent } from "./common/select-layers/select-layers.component";
import { DevDisableScrollInputComponent } from "./development/ui/dev-disable-scroll-input.component";
import { PreventInputScrollDirective } from "./_directives/prevent-input-scroll/prevent-input-scroll.directive";
import { AbstractService } from "./_services/abstract/abstract.service";
import { CreateParentEventFormBudgetSection } from "./admin/events-screen/create-parent-event-form-budget-section/create-parent-event-form-budget-section.component";
import { BudgetSectionSearchBoxComponent } from "./admin/events-screen/create-parent-event-form-budget-section/budget-section-search-box/budget-section-search-box.component";
import { DevReceiptMechanismComponent } from "./development/ui/dev-receipt-mechanism.component";
import { DownloadReceiptService } from "./_services/download-receipt.service";
import { DevReceiptScreenComponent } from "./development/ui/dev-receipt-screen.component";
import { ReceiptPageComponent } from "./admin/receipt/receipt-page/receipt-page.component";

import { ReceiptPageSearchComponent } from "./admin/receipt/receipt-page-search/receipt-page-search.component";
import { ReceiptPageSearchChildComponent } from "./admin/receipt/receipt-page-search-child/receipt-page-search-child.component";
import { ReceiptPageSearchEventComponent } from "./admin/receipt/receipt-page-search-event/receipt-page-search-event.component";
import { ReceiptPageSearchReceiptIssuerComponent } from "./admin/receipt/receipt-page-search-receipt-issuer/receipt-page-search-receipt-issuer.component";
import { ReceiptTableRowComponent } from "./admin/receipt/receipt-table-row/receipt-table-row.component";
import { ReceiptTableRowHeader } from "./admin/receipt/receipt-table-row-header/receipt-table-row-header.component";
import { ReceiptTableRowDetailsChildReceiptRowComponent } from "./admin/receipt/receipt-table-row-details-child-receipt-row/receipt-table-row-details-child-receipt-row.component";
import { ReceiptDeleteModalComponent } from "./admin/receipt/receipt-utils-delete-modal/receipt-delete-modal.component";
import { ReceiptPageSubmitReceiptModalContainerComponent } from "./admin/receipt/receipt-page-submit-receipt-modal-container/receipt-page-submit-receipt-modal-container.component";
import { ReceiptPageSubmitReceiptModalComponent } from "./admin/receipt/receipt-page-submit-receipt-modal/receipt-page-submit-receipt-modal.component";
import { ReceiptPageSubmitReceiptModalUploadFilesComponent } from "./admin/receipt/receipt-page-submit-receipt-modal-uplaod-files/receipt-page-submit-receipt-modal-upload-files.component";
import { ReceiptPageSubmitReceiptModalDisplayChecksComponent } from "./admin/receipt/receipt-page-submit-receipt-modal-display-checks/receipt-page-submit-receipt-modal-display-checks.component";
import { ReceiptUtilTestsUploadComponent } from "./admin/receipt/receipt-util-tests-upload/receipt-util-tests-upload.component";
import { CheckContributionWarningComponent } from "./checkout/check-contribution-warning/check-contribution-warning.component";
import { WaitForPaymentComponent } from "./payment/wait-for-payment/wait-for-payment.component";
import { ReceiptManagementService } from "./_services/receipt-management.service";
import { OrDevComponent } from './or-dev/or-dev.component';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ToastModule.forRoot(),
    NgxEditorModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    NgIdleKeepaliveModule.forRoot(),
    NgbModule.forRoot(),
    YoutubePlayerModule,
    FileDropModule,
    routing,
    AgGridModule.withComponents([
      HistoryDetailComponent,
      HistoryActionComponent,
      HistoryFieldComponent,
    ]),
    HttpClientModule,
    RecaptchaModule.forRoot(),
    RecaptchaFormsModule,
    NgSpinKitModule,
    NgwWowModule.forRoot(),
    NgbTooltipModule.forRoot(),
    VirtualScrollerModule,
    ChartsModule,
    LoggerModule,
  ],
  declarations: [
    AppComponent,
    AlertComponent,
    TextComponent,
    LegacyHeaderComponent,
    AccessibilityComponent,
    QuestionsAnswersComponent,
    HomeComponent,
    CartComponent,
    LegacyLoginComponent,
    TwoFactorLoginComponent,
    RegisterComponent,
    ForgotPasswordComponent,
    CheckoutComponent,
    BrothersComponent,
    BrothersPanelComponent,
    CreateChildComponent,
    ViewChildComponent,
    ChildModal, //         FormComponent,
    DevSelectMenuComponent,
    DevDiscountTableStoryComponent,
    MultiSelectMenuComponent,
    RefundComponent,
    SearchComponent,
    RegisteredUserComponent,
    ViewParentComponent,
    EditParentComponent,
    SearchParentComponent,
    AdminComponent,
    MihlolModal,
    MihlolComponent,
    MeshutafUsersComponent,
    MeshutafUserFormComponent,
    ContentComponent,
    RikuzComponent,
    RefundsAdminComponent,
    CirleBrDiscountsComponent,
    EventMeshutafComponent,
    SelectAreaComponent,
    AutoCompleteComponent,
    MultiSelectComponent,
    RangeSelectComponent,
    CashComponent,
    OpenReceiptsComponent,
    PaymentsComponent,
    PaymentResultComponent,
    RefundInlineComponent,
    RefundBlockComponent,
    SingleReceiptComponent,
    DepositModalComponent,
    CollectiveReceiptComponent,
    BooleanComponent,
    SearchChildModal,
    RefundLogicComponent,
    PaymentOkComponent,
    PaymentNotOkComponent,
    HistoryComponent,
    HistoryDetailComponent,
    HistoryActionComponent,
    HistoryFieldComponent,
    NgbdModalBasic,

    PersonalIdValidator,
    PersonalIdAdminValidator,
    PasswordValidator,
    RepeatPasswordValidator,
    NestValidator,
    CountryValidator,
    PhoneValidator,
    PageHeaderComponent,
    KeysPipe,
    EventNamePipe,
    UserPipe,
    TrimTextPipe,
    QuestionsComponent,
    QuestionsModal,
    ApprovalModalComponent /** Father events  */,
    CreateParentEventFormMainDetailsComponent,
    CreateParentEventFormPricingRowComponent,
    CreateParentEventFormPricingNestsComponent,
    CreateParentEventFormPricingListComponent,
    CreateParentEventFormParentQuestionsComponent,
    CreateParentEventFormParentQuestionsCardComponent,
    QuestionsCardOptionComponent,
    CreateParentEventFormComponent,
    CreateParentEventFormCustomComponent,
    ParentEventsPageComponent,
    GenericFormComponent,
    GenericAutoCompleteComponent,
    CreateParentEventPageFormUsersPermissions,
    CreateParentEventUserPermissionRow,
    CreateParentEventFormBudgetSection,
    ParentEventsRowComponent,
    ParentEventsRowHeaderComponent,
    ParentEventsRowDetailsComponent,
    ParentEventsMessagesComponent,
    EventPageLoadingAnimationComponent,
    EventPageSearchComponent,
    EventPageModal,
    ParentEventsPageMainModalContainerComponent,
    SelectMenuComponent,
    ParentEventsRowDetailsChildEventsRowComponent,
    GenericActionMenuComponent,
    TooltipDirective,
    PreventInputScrollDirective,
    InfiniteScrollerDirective,
    GenericModalComponent,
    WhiteBoardComponent,
    SelectDateComponent,

    /**real EventTypeManagement */
    EventTypeManagementScreenComponent,
    EventsTypeManagementRowHeaderComponent,
    EventsTypeManagementRowComponent /** Brother attribution */,
    BrothersAttributionPage,
    LegacyBrotherAttributionMainChildSearchComponent,
    BrotherAttributionRequestRow,
    BrotherAttributionRequestRowHeader,
    BrotherAttributionPageMainModalContainerComponent,

    FamilyCreationFormComponent,
    FamilyEditFormComponent,
    BrotherAttributionChildSelector,
    BrotherAttributionFamilyEditorComponent,
    BrotherAttributionSearchChildComponent,
    BrotherAttributionBriefResultsViewComponent,
    PopoverContainerComponent,
    TextTrimPopoverComponent,
    LegacyTextTrimPopoverComponent,

    GenericCheckBoxComponent,
    GenericCheckBoxWithMinusComponent,

    /** new Header */
    AppHeaderComponent /** Development */,
    DevelopmentComponent,
    StoriesComponent,
    SpinnerWithCheckMarkComponent /** User management */,
    FigmaLinkComponent,
    UserManagementPageComponent,
    UsersManagementSearchComponent,
    UserManagementRowComponent,
    UserManagementRowHeaderComponent,
    UserManagementUploadUsersExcelModalComponent,
    UploadExcelFileInterfaceComponent,
    UserManagementSearchBoxComponent,
    MultiSelectNestsComponent,
    UserManagementFormComponent,
    UserManagementFormMainModalContainerComponent,
    UserManagementFormPersonalDetailsComponent,
    AsyncValidationIndicatorComponent,
    FormFieldErrorComponent,
    UserManagementFormSystemPrivilegesComponent,
    PinCodeInputComponent,
    CodeCubesComponent,
    UserManagementFormActivityFieldsComponent,
    UserManagementFormActivityNestsComponent,
    UserManagementFormPasswordManagementComponent,
    DateRangeSelectComponent,
    UserManagementActivityForm,
    PasswordResetModalComponent,
    PasswordResetApprovalModalComponent,
    UserManagementBriefResultsViewComponent,
    MultiSelectNestsComponent,
    RestUserPasswordComponent,
    DiscountManagementBriefResultsViewComponent,
    DiscountManagementPageComponent,
    DiscountManagementSearchEventComponent,
    DiscountManagementSearchBoxComponent,
    UsersManagementSearchComponent,
    MultiSelectEventsComponent,
    MultiSelectLayersComponent, // discount management
    DiscountManagementRowComponent,
    DiscountManagementSearchComponent,
    DiscountManagementSearchChildComponent,
    NewDiscountFormComponent,
    DiscountManagementFormMainModalContainerComponent,
    NewDiscountFormSelectEventComponent,
    NewDiscountFormSelectEventParentComponent,
    NewDiscountFormSelectChildrenComponent,
    NewDiscountFormSelectPriceComponent,
    NewDiscountFormSummaryComponent,
    EditDiscountFormComponent,
    DiscountManagementDeleteModalComponent,
    EditDiscountFormSelectPriceComponent,
    AppSpinnerComponent,
    AppLoadingDataComponent,
    DevEndpointExampleComponent,
    DevSelectOrganComponent,
    DevDisableScrollInputComponent,
    SelectOrgansComponent, // Add the new SelectOrgansComponent
    MockTestComponent,
    FreePayComponent,
    GenericChartComponent,
    GenericChartModalContainerComponent,
    LastStoriesComponent,
    ContributionComponent,
    WaveEffect,
    SelectOrgansCustomMultiSelectComponent,
    SelectLayersComponent,
    BudgetSectionSearchBoxComponent,
    DevReceiptMechanismComponent,
    DevReceiptScreenComponent,
    ReceiptPageComponent,
    ReceiptPageSearchComponent,
    ReceiptPageSearchChildComponent,
    ReceiptPageSearchEventComponent,
    ReceiptPageSearchReceiptIssuerComponent,
    ReceiptTableRowComponent,
    ReceiptTableRowHeader,
    ReceiptTableRowDetailsChildReceiptRowComponent,
    ReceiptDeleteModalComponent,
    ReceiptPageSubmitReceiptModalContainerComponent,
    ReceiptPageSubmitReceiptModalComponent,
    ReceiptPageSubmitReceiptModalUploadFilesComponent,
    ReceiptPageSubmitReceiptModalDisplayChecksComponent,
    ReceiptUtilTestsUploadComponent,
    CheckContributionWarningComponent,
    WaitForPaymentComponent,
    OrDevComponent,
  ],
  providers: [
    AuthGuard,
    StagingGuard,
    AlertService,
    AuthenticationService,
    AbstractService,
    DataService,
    DatePipe,
    NgbActiveModal,
    ApplicationService,
    HttpWrapperService,
    LocalStorageManagerService,
    LocationManagerService,
    ParentService,
    EventsService,
    SpecialTypeEventsService,
    EventSerializerService,
    EventValidationService,
    I18nService,
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    SessionManagerService,
    EventsTypesManagementService,
    FormGroupDirective,
    PreventInputScrollDirective,
    TranslationService,
    BrotherAttributionService,
    PopoverService,
    UserManagementService,
    PasswordResetService,
    GlobalDataService,
    DiscountManagementService,
    LanguageService,
    DevToolsService,
    ChartService,
    FilesService,
    DownloadReceiptService,
    ReceiptManagementService,
  ],
  entryComponents: [
    ApprovalModalComponent,
    GenericModalComponent,
    ParentEventsPageMainModalContainerComponent,
    BrotherAttributionPageMainModalContainerComponent,
    UserManagementUploadUsersExcelModalComponent,
    UserManagementFormMainModalContainerComponent,
    DiscountManagementFormMainModalContainerComponent,
    PasswordResetModalComponent,
    PasswordResetApprovalModalComponent,
    DiscountManagementDeleteModalComponent,
    FreePayComponent,
    GenericChartComponent,
    GenericChartModalContainerComponent,
    ReceiptPageComponent,
    ReceiptPageSubmitReceiptModalContainerComponent,
    ReceiptUtilTestsUploadComponent,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts